import { useState } from "react";
import { useTranslation } from "react-i18next";

const faqKeys = ["q1", "q2", "q3", "q4", "q5", "q6", "q7"];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-2xl font-bold text-foreground-950 md:text-4xl">{t("faq.title")}</h2>
        <p className="mt-3 text-base text-foreground-600">{t("faq.subtitle")}</p>
      </div>

      <div className="mx-auto mt-10 max-w-3xl space-y-3">
        {faqKeys.map((key, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={key} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : i)}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <span className="font-heading text-base font-semibold text-foreground-900">{t(`faq.questions.${key}`)}</span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform ${
                    isOpen ? "rotate-45" : ""
                  }`}
                >
                  <i className="ri-add-line" />
                </span>
              </button>
              {isOpen && <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{t(`faq.questions.${key.replace("q", "a")}`)}</p>}
            </div>
          );
        })}
      </div>
    </section>
  );
}